export enum BAEMIN_CATEGORY_CODE {
  FAST_FOOD = 'FAST_FOOD',
  VEGETARIAN = 'VEGETARIAN',
  BENTO = 'BENTO',
  SOUP = 'SOUP',
  LATE_NIGHT = 'LATE_NIGHT',
  PORK_BOSSAM = 'PORK_BOSSAM',
  CHINESE = 'CHINESE',
  ASIAN_WESTERN = 'ASIAN_WESTERN',
  CHICKEN = 'CHICKEN',
  KATSU_SASHIMI_JAPANESE = 'KATSU_SASHIMI_JAPANESE',
  CAFE_DESSERT = 'CAFE_DESSERT',
  SNACK_MEAL = 'SNACK_MEAL',
  KOREAN = 'KOREAN',
}

export const CONST_BAEMIN_CATEGORY_CODE = Object.values(BAEMIN_CATEGORY_CODE);

export enum BAEMIN_CATEGORY_CODE_KOREAN {
  FAST_FOOD = '패스트푸드',
  VEGETARIAN = '채식',
  BENTO = '도시락',
  SOUP = '찜/탕',
  LATE_NIGHT = '야식',
  PORK_BOSSAM = '족발/보쌈',
  CHINESE = '중국집',
  ASIAN_WESTERN = '아시안/양식',
  CHICKEN = '치킨',
  KATSU_SASHIMI_JAPANESE = '돈까스/회/일식',
  CAFE_DESSERT = '카페/디저트',
  SNACK_MEAL = '분식',
  KOREAN = '한식',
}

export const CONST_BAEMIN_CATEGORY_CODE_KOREAN = Object.values(
  BAEMIN_CATEGORY_CODE_KOREAN,
);
